import { FilterActions } from "@next-platform/client-common-spicy-ui";

import { EXCLUDED_REFINEMENT_PREFIX } from "./constants";

type ExcludableAction = FilterActions.INCLUDE | FilterActions.EXCLUDE;

export default function applyExcludableRefinement({
  action,
  value,
  selectedRefinements,
  refine,
}: {
  action: ExcludableAction;
  value: string;
  selectedRefinements: readonly string[];
  refine: (value: string) => void;
}): void {
  const excludedValue = `${EXCLUDED_REFINEMENT_PREFIX}${value}`;
  if (action === FilterActions.INCLUDE) {
    if (selectedRefinements.includes(excludedValue)) {
      refine(excludedValue);
    }
    refine(value);
    return;
  }

  if (selectedRefinements.includes(value)) {
    refine(value);
  }
  refine(excludedValue);
}
